import React from "react"
import { EditorState, Modifier, RichUtils } from "draft-js"
import { fontSizeStyleMap } from "../../../../../../libs/style-map"
import { FONT_SIZE } from "../../../../../../../../../../style/const/chat/inline_style"
import { ChangeEvent } from "react"
import { IToolBarProps } from "."
import { StyledSelect } from "../../../../../../../../../../components/parts/styled-select"
import { FONT_SIZE_STYLE_MAP_WITH_BUTTON_TITLE } from "../../../../../../libs/style-info"

export const FontSizeSelect = (props: IToolBarProps) => {
  const toggleSize = ({ target }: ChangeEvent<HTMLSelectElement>) => {
    const toggledSize: FONT_SIZE = target.value as FONT_SIZE
    const editorState = props.editorState
    const selection = editorState.getSelection()
    const currentStyle = editorState.getCurrentInlineStyle()

    const nextContentState = Object.keys(fontSizeStyleMap).reduce(
      (contentState, size) =>
        Modifier.removeInlineStyle(contentState, selection, size),
      editorState.getCurrentContent(),
    )

    let nextEditorState = EditorState.push(
      editorState,
      nextContentState,
      "change-inline-style",
    )

    if (!currentStyle.has(toggledSize)) {
      nextEditorState = RichUtils.toggleInlineStyle(
        nextEditorState,
        toggledSize,
      )
    }

    props.onChange(nextEditorState)
  }

  return (
    <StyledSelect
      onChange={toggleSize}
      value={""}
      options={FONT_SIZE_STYLE_MAP_WITH_BUTTON_TITLE}
    />
  )
}
